import React, { createContext, useState, useEffect, useContext, useCallback, useMemo } from 'react';

// Create the context
export const CalculatorContext = createContext();

// Create a hook to use the calculator context
export function useCalculator() {
  return useContext(CalculatorContext);
}

export const CalculatorProvider = ({ children }) => {
  // State for calculator visibility and detached state
  const [showCalculator, setShowCalculator] = useState(() => {
    const savedState = localStorage.getItem('persistentCalculatorVisible');
    return savedState ? JSON.parse(savedState) : false;
  });
  
  const [isCalculatorDetached, setIsCalculatorDetached] = useState(() => {
    const savedState = localStorage.getItem('persistentCalculatorDetached');
    return savedState ? JSON.parse(savedState) : false;
  });

  // Update localStorage when state changes
  useEffect(() => {
    localStorage.setItem('persistentCalculatorVisible', JSON.stringify(showCalculator));
  }, [showCalculator]);

  useEffect(() => {
    localStorage.setItem('persistentCalculatorDetached', JSON.stringify(isCalculatorDetached));
  }, [isCalculatorDetached]);

  // Handle toggling the calculator visibility
  const handleCalculatorToggle = useCallback(() => {
    setShowCalculator(prevShowCalculator => {
      if (prevShowCalculator) {
        setIsCalculatorDetached(false);
        return false;
      }
      setIsCalculatorDetached(true);
      return true;
    });
  }, []);

  // Handle closing the calculator
  const handleCalculatorClose = useCallback(() => {
    setShowCalculator(false);
    setIsCalculatorDetached(false);
  }, []);

  const value = useMemo(() => ({
    showCalculator,
    setShowCalculator,
    isCalculatorDetached,
    setIsCalculatorDetached,
    handleCalculatorToggle,
    handleCalculatorClose
  }), [showCalculator, isCalculatorDetached, handleCalculatorToggle, handleCalculatorClose]);

  return (
    <CalculatorContext.Provider value={value}>
      {children}
    </CalculatorContext.Provider>
  );
};

export default CalculatorProvider; 